/* src/app/components/chat-list/chat-message/chat-message.component.scss */
.chat-user-list {
  position: absolute;
  right: 0px;
  z-index: 9;
  top: 62px;
}
.chat-tab a.active .fa,
.chat-tab a.active .pi {
  color: var(--listcolor) !important;
}
footer.chats {
  background: #eee !important;
}
footer.chats ::ng-deep .control.is-expanded:focus,
footer.chats ::ng-deep .control.is-expanded:focus-within {
  box-shadow: none !important;
  border: none !important;
}
footer.chats .is-grouped:focus-within,
footer.chats .is-grouped:focus {
  border-color: #b7b4b4 !important;
  box-shadow: none !important;
  min-height: 60px !important;
}
footer.chats .is-grouped {
  border-color: #b7b4b4;
  border-radius: 10px !important;
  min-height: 60px !important;
}
/*# sourceMappingURL=chat-message.component.css.map */
